export default __webpack_public_path__ + "static/media/alex.f054e35b.jpeg";